import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from '../../../../environments/environment';
import { ListResultDTO } from '../../../helpers/listResult.interface copy';
import { ClosuresDTO, ClosuresFilters } from '../../models/closures';

@Injectable({
    providedIn: 'root',
})
export class LaravelClosuresService {
    constructor(private httpClient: HttpClient) {}

    private get ROUTES() {
        return {
            list: environment.baseUrl + '/api/closures',
            show: environment.baseUrl + '/api/closures',
            store: environment.baseUrl + '/api/closures',
            destroy: environment.baseUrl + '/api/closures',
        };
    }

    public list(
        page: number,
        per_page: number,
        order: string,
        direction: string,
        filters: ClosuresFilters,
        includes?: string[]
    ): Observable<ListResultDTO<ClosuresDTO>> {
        let params = {};

        if (page) params["page"] = "" + page;
        if (per_page) params["per_page"] = "" + per_page;
        if (order) params["order"] = "" + order;
        if (direction) params["direction"] = "" + direction;
        if (includes) params["includes[]"] = includes;
        if (filters) {
            if (filters.closure_date) {
                const localDate = new Date(filters.closure_date.getTime() - filters.closure_date.getTimezoneOffset() * 60000);
                params['closure_date'] = localDate.toISOString().split('T')[0];
            }
            if (filters.tenant_id) params["tenant_id"] = "" + filters.tenant_id;            
        }
        
        if (per_page) {
            params['per_page'] = '' + per_page;
            if (page) params['page'] = '' + page;
            return this.httpClient.get<ListResultDTO<ClosuresDTO>>(
            this.ROUTES.list,
            {
                params: new HttpParams({ fromObject: params }),
            }
            );
        } else {
            return this.httpClient
            .get<ClosuresDTO[]>(this.ROUTES.list, {
                params: new HttpParams({ fromObject: params }),
            })
            .pipe(
                map((results) => {
                return {
                    data: results,
                    total: results.length,
                };
                })
            );
        }
    }

    public show(id: number): Observable<ClosuresDTO> {
        let params = { id: '' + id };
        return this.httpClient.get<ClosuresDTO>(`${this.ROUTES.show}/${id}`, {
          params: new HttpParams({
            fromObject: params,
          }),
        });
    }

    public upsert(closure: ClosuresDTO): Observable<ClosuresDTO> {
        if (closure.id) {
          return this.httpClient.put<ClosuresDTO>(`${this.ROUTES.store}/${closure.id}`, closure); 
        } else {
          return this.httpClient.post<ClosuresDTO>(`${this.ROUTES.store}`, closure);
        }
    }
    
    public delete(id: number) {
    //let params = new HttpParams().set("id", "" + id);
    return this.httpClient.delete(this.ROUTES.destroy + "/" + id);
    }
}